import styled from 'styled-components'
import { Box, Typography } from 'src/components'

export const OverSection = styled(Box)`
    width: 96%;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 96%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 758px;
        flex-direction: column;
        justify-content: start;
        align-items: center;
    }
`
export const Image = styled.img`
    width: 100%;
    height: 300px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        height: 400px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: auto;
        height: 400px;
    }
`
export const DataContent = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: start;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const DataContentCode = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: start;
    height: auto;
    border: 1px solid white;
    background: rgba(128, 128, 128, 0.49);
    padding: 8px;
    margin: 6px 0;
    border-radius: 8px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const SectionData = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 140%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`

export const SectionDataTypography = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    line-height: 160%;
    font-size: 18px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
